import { render } from "./TopCustomers.vue?vue&type=template&id=dca8480e&scoped=true&ts=true"
import script from "./TopCustomers.vue?vue&type=script&lang=ts"
export * from "./TopCustomers.vue?vue&type=script&lang=ts"

import "./TopCustomers.vue?vue&type=style&index=0&id=dca8480e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca8480e"]])

export default __exports__